import React from 'react'
import NavAfterLogin from '../components/Navbar/NavAfterLogin'
import PostDetails from '../components/Post/PostDetails'

const PostDetailsPage = () => {
    return (
      <>
        <NavAfterLogin/>
        <PostDetails/>
      </>
    )
  }
  
  export default PostDetailsPage